export enum WalletConnectNamespace {
  EVM = "eip155",
  SOLANA = "solana",
  BITCOIN = "bip122",
  TRON = "tron",
}

export enum WalletMetadata {
  NAME = "Relm Checkout",
  DESCRIPTION = "Relm wallet verification",
}
